$(document).ready(function() {
	$.validator.addMethod("nameLength", function(value){
		var nameLength = $("#name").val().length;
		var surnameLength = $("#surname").val().length;
			if (nameLength + surnameLength >= 50) {
				return false;
			}
			return true;
		
	}, jQuery.validator.messages.busNameLength);		
});

function clearPassInfos() {
	
	var form = $('#reservationForm');
	$("[inputType=name]", form).val("");
	$("[inputType=surname]", form).val("");
	$("[itype=idno]", form).val("");
	$("[itype=passNo]", form).val("");
	$("#phone").val("");
	$("#gsm").val("");
	$("#email").val("");

}